

























import { vxm } from '../store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 7000,
});

@Component({
  name: 'JobAlertDeactivation',
  components: {},
})
export default class JobAlertDeactivation extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private successString: string = '';
  private displayMessage: string = '';
  private errorFlag: boolean = false;
  @Prop() private code!: string;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public deactivateJobAlerts(hash) {
    vxm.jobs.deactivateJobAlerts(hash).then((res) => {
      if (res === true) {
        // this.$wlToastr('success', this.$t(this.successString), 'You will no longer receive daily email updates pertaining to the search criteria you initially specified.');
        this.$wlToastr(
          'success',
          this.$t(this.successString),
          'Your alerts have been paused. You will no longer receive job alerts for your search criteria.',
        );
        console.log(this.successString);
        this.displayMessage =
          'Your alerts have been paused. You will no longer receive job alerts for your search criteria.';
        //  this.displayMessage = 'Job Alert deactivated successfully. You will no longer receive email updates pertaining to the search criteria you initially specified.';
        return true;
      } else {
        this.$wlToastr(
          'error',
          this.$t(this.errorString),
          'Error! Could not deactivate job alerts!',
        );
        this.displayMessage = 'Error! Could not deactivate job alerts!';
        this.errorFlag = true;
        //console.log(this.errorString);
        return false;
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  mounted() {
    console.log('code is:' + this.code);
    this.deactivateJobAlerts(this.code);
  }
}
